var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#0A1E60","fillRule":"evenodd","d":"M3.75 7.333c.973 0 1.814-.354 2.522-1.061.707-.708 1.061-1.549 1.061-2.522 0-.973-.354-1.814-1.061-2.522C5.564.521 4.723.167 3.75.167c-.973 0-1.814.354-2.522 1.061C.521 1.936.167 2.777.167 3.75c0 .973.354 1.814 1.061 2.522.708.707 1.549 1.061 2.522 1.061Zm12.382 21.5V19.16c0-1.526.215-2.68.644-3.465.56-1.046 1.526-1.569 2.902-1.569 1.375 0 2.3.589 2.772 1.765.258.698.387 1.83.387 3.4v9.542h5.996v-10.72c0-3.006-.43-5.228-1.29-6.666-1.117-1.787-3.072-2.68-5.866-2.68-1.376 0-2.58.348-3.611 1.045-.946.567-1.633 1.286-2.063 2.157h-.065V9.29H10.2v19.544h5.932Zm-10.232 0V10.2H.167v18.633H5.9Z"}));
}

Linkedin.defaultProps = {"viewBox":"0 0 29 29"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
